import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import React, { useState } from "react";
import GridViewIcon from "@mui/icons-material/GridView";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const ViewToggleSwitch = ({ setMode ,disable=false}) => {
  const [btnMode, setBtnMode] = useState("Card View");
  return (
    <ToggleButtonGroup size="medium">
      <Tooltip title={<p style={{ fontSize: "1.5rem" }}>Table View</p>}>
      <ToggleButton
        sx={{
          padding: "5px",
          background: `${btnMode === "Table View" ? "#f2f4f7" : ""}`,
        }}
        disabled={disable}
        onClick={() => {
          setMode("Table View");
          setBtnMode("Table View");
        }}
      >
        <FormatListBulletedIcon style={{ width: "30px", height: "30px"  }} />
      </ToggleButton>
      </Tooltip>
      <Tooltip title={<p style={{ fontSize: "1.5rem" }}>Grid View</p>}>
      <ToggleButton
        sx={{
          padding: "5px",
          background: `${btnMode === "Card View" ? "#f2f4f7" : ""}`,
        }}
        onClick={() => {
          setMode("Card View");
          setBtnMode("Card View");
        }}
        disabled={disable}
      >
        <GridViewIcon style={{ width: "27px", height: "27px" }} />
      </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ViewToggleSwitch;
